module.exports = __webpack_public_path__ + "static/bitcoinlinks-5484c8d93c941d6639232437c013d7c7.jpg";